import { render, staticRenderFns } from "./test_question_mobile.vue?vue&type=template&id=323ea054&scoped=true"
import script from "./test_question_mobile.vue?vue&type=script&lang=js"
export * from "./test_question_mobile.vue?vue&type=script&lang=js"
import style0 from "./test_question_mobile.vue?vue&type=style&index=0&id=323ea054&prod&lang=less&scoped=true"
import style1 from "./test_question_mobile.vue?vue&type=style&index=1&id=323ea054&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323ea054",
  null
  
)

export default component.exports